import React, { FC } from 'react';
import { Box, Typography, useTheme, makeStyles } from '@dxb-web-ui-framework/design-system';
import { useScreenDetector } from '@dxb-web-ui-framework/common/hooks';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(({ spacing }) => ({
  motoFont: {
    fontSize: 50,
  },
  motoFontMobile: {
    fontSize: 40,
    lineHeight: 1,
  },
  sloganFont: {
    fontSize: 19,
  },
  sloganFontMobile: {
    marginTop: '10px',
  },
}));

type CardHeroBannerTextProps = {
  moto?: string;
  slogan?: string;
};

const CardHeroBannerText: FC<CardHeroBannerTextProps> = ({ moto, slogan }) => {
  const { isExtraSmallScreen: isMobile } = useScreenDetector();
  const theme = useTheme();
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Box display={'flex'} height='100%' width={'100%'} flexDirection={'column'}>
      {moto && slogan ? (
        <>
          <Box>
            <Typography variant={isMobile ? 'h6' : 'h3'} color={'primary'}>
              {t(moto)}
            </Typography>
          </Box>
          <Box mt={isMobile ? 2 : 4} mr={isMobile ? 2 : 4}>
            <Typography variant={isMobile ? 'body1' : 'h6'}>{t(slogan)}</Typography>
          </Box>
        </>
      ) : (
        <>
          <Box>
            <Typography
              variant={isMobile ? 'h6' : 'h3'}
              className={isMobile ? classes.motoFontMobile : classes.motoFont}>
              {t('issueCard.layout.Moto.Default.Text1')}
              <Box component={'span'} style={{ color: theme.palette.primary.main }}>
                &nbsp;
                {t('issueCard.layout.Moto.Default.Text2')}
                &nbsp;
              </Box>
              {t('issueCard.layout.Moto.Default.Text3')}
            </Typography>
            <Typography
              variant={isMobile ? 'h6' : 'h3'}
              className={isMobile ? classes.motoFontMobile : classes.motoFont}>
              {t('issueCard.layout.Moto.Default.Text4')}
            </Typography>
          </Box>
          <Box mt={isMobile ? 0 : 4} mr={isMobile ? 2 : 4}>
            <Typography
              variant={isMobile ? 'body1' : 'h6'}
              className={isMobile ? classes.sloganFontMobile : classes.sloganFont}>
              {t('issueCard.layout.Slogan.Default')}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

export { CardHeroBannerText };
